import { Polygon } from "maptalks-gl";
import { MapRegion, MapComune } from "../../types";

export const getBackgroundPolygon = (): any => {
  return new Polygon(
    [
      [
        [-90, 45],
        [-80, 65],
        [-55, 75],
        [-20, 78],
        [15, 70],
        [45, 55],
        [75, 35],
        [90, 0],
        [80, -40],
        [55, -70],
        [20, -80],
        [-20, -78],
        [-55, -70],
        [-80, -40],
        [-90, -5],
        [-90, 20],
        [-90, 45],
      ],
    ],
    {
      symbol: {
        polygonFill: "#eeece2",
        polygonOpacity: 1,
        lineWidth: 10,
        lineColor: "#f7f5ee",
        lineOpacity: 1,
      },
      cursor: "auto",
    },
  );
};

const GUITARS_REGION_VERTICES: [number, number][] = [
  [22, -33],
  [28, -30],
  [35, -32],
  [40, -37],
  [42, -43],
  [39, -48],
  [33, -50],
  [27, -48],
  [23, -43],
  [22, -38],
  [22, -33],
];

function isPointInPolygon(
  point: [number, number],
  polygon: [number, number][],
): boolean {
  const [x, y] = point;
  let inside = false;
  const n = polygon.length;
  for (let i = 0, j = n - 1; i < n; j = i++) {
    const xi = polygon[i][0],
      yi = polygon[i][1];
    const xj = polygon[j][0],
      yj = polygon[j][1];
    const intersect =
      yi > y !== yj > y && x < ((xj - xi) * (y - yi)) / (yj - yi) + xi;
    if (intersect) inside = !inside;
  }
  return inside;
}

interface GuitarsComuneBase {
  name: string;
  origCenter: [number, number];
  polygonVertices?: [number, number][];
  tooltip?: string;
  href?: string;
  target?: string;
}

interface GuitarsCityBase {
  id: string;
  name: string;
  origCenter: [number, number];
  polygonVertices: [number, number][];
  comuni: GuitarsComuneBase[];
}

const GUITARS_CITIES_BASE: GuitarsCityBase[] = [
  {
    id: "city3a",
    name: "boom",
    origCenter: [26, -38],
    polygonVertices: [
      [25.0, -36.6],
      [25.8, -36.4],
      [26.6, -36.5],
      [27.4, -36.9],
      [27.8, -37.4],
      [27.6, -38.0],
      [27.8, -38.6],
      [27.2, -39.2],
      [26.4, -39.4],
      [25.2, -39.2],
      [24.6, -38.6],
      [24.4, -37.8],
      [24.5, -37.2],
      [25.0, -36.6],
    ],
    comuni: [
      {
        name: "diapason",
        origCenter: [26.5, -37.2],
        polygonVertices: [
          [26.6, -37.0],
          [26.8, -37.2],
          [26.7, -37.5],
          [26.4, -37.6],
          [26.2, -37.4],
          [26.2, -37.1],
          [26.5, -37.0],
          [26.6, -37.0],
        ],
      },
      {
        name: "monoblocco",
        origCenter: [25.5, -38.5],
        polygonVertices: [
          [25.2, -38.3],
          [25.6, -38.2],
          [25.9, -38.4],
          [25.9, -38.7],
          [25.5, -38.9],
          [25.1, -38.7],
          [25.1, -38.5],
          [25.2, -38.3],
        ],
      },
    ],
  },
  {
    id: "city3b",
    name: "roar",
    origCenter: [35, -42],
    polygonVertices: [
      [33.6, -41.4],
      [34.0, -40.8],
      [34.8, -40.2],
      [35.6, -40.0],
      [36.4, -40.2],
      [37.2, -40.6],
      [37.6, -41.2],
      [37.4, -41.8],
      [36.8, -42.0],
      [37.0, -42.6],
      [36.6, -43.2],
      [35.8, -43.0],
      [35.2, -43.4],
      [34.6, -43.2],
      [34.0, -42.8],
      [33.6, -42.6],
      [33.2, -42.0],
      [33.6, -41.4],
    ],
    comuni: [
      {
        name: "tretrecinque",
        origCenter: [34.5, -42.5],
        polygonVertices: [
          [34.0, -42.2],
          [34.5, -42.1],
          [35.0, -42.3],
          [35.0, -42.7],
          [34.6, -42.9],
          [34.1, -42.8],
          [33.9, -42.5],
          [34.0, -42.2],
        ],
      },
      {
        name: "lv",
        origCenter: [35.6, -40.9],
        polygonVertices: [
          [35.3, -40.6],
          [35.7, -40.5],
          [36.1, -40.7],
          [36.1, -41.1],
          [35.7, -41.3],
          [35.3, -41.2],
          [35.1, -40.9],
          [35.3, -40.6],
        ],
      },
      {
        name: "venere",
        origCenter: [36.5, -41.8],
        polygonVertices: [
          [36.2, -41.5],
          [36.6, -41.4],
          [36.9, -41.6],
          [36.9, -42.0],
          [36.6, -42.2],
          [36.2, -42.0],
          [36.1, -41.7],
          [36.2, -41.5],
        ],
      },
    ],
  },
  {
    id: "city3c",
    name: "slurp",
    origCenter: [31, -36],
    polygonVertices: [
      [30.0, -34.2],
      [30.8, -33.6],
      [31.6, -33.8],
      [32.4, -34.0],
      [33.2, -34.6],
      [33.6, -35.4],
      [33.4, -36.2],
      [33.0, -36.8],
      [32.6, -37.4],
      [31.8, -37.8],
      [31.0, -38.0],
      [30.2, -37.6],
      [29.4, -37.0],
      [28.8, -36.4],
      [28.6, -35.6],
      [29.0, -34.8],
      [29.6, -34.4],
      [30.0, -34.2],
    ],
    comuni: [
      {
        name: "felipe",
        origCenter: [31.6, -34.8],
        polygonVertices: [
          [31.3, -34.5],
          [31.7, -34.4],
          [32.0, -34.6],
          [32.1, -35.0],
          [31.8, -35.2],
          [31.4, -35.1],
          [31.2, -34.8],
          [31.3, -34.5],
        ],
      },
      {
        name: "mono",
        origCenter: [30.2, -36.5],
        polygonVertices: [
          [30.3, -36.2],
          [30.6, -36.3],
          [30.7, -36.6],
          [30.5, -36.8],
          [30.1, -36.9],
          [29.9, -36.6],
          [30.0, -36.3],
          [30.3, -36.2],
        ],
      },
      {
        name: "pinderbass",
        origCenter: [32.5, -34.8],
        polygonVertices: [
          [32.3, -34.4],
          [32.6, -34.4],
          [32.8, -34.7],
          [32.7, -35.1],
          [32.5, -35.3],
          [32.2, -35.2],
          [32.1, -34.9],
          [32.2, -34.6],
          [32.3, -34.4],
        ],
      },
      {
        name: "miscellanea",
        origCenter: [31.6, -36.8],
        polygonVertices: [
          [31.3, -36.5],
          [31.7, -36.4],
          [32.0, -36.6],
          [32.0, -37.0],
          [31.6, -37.2],
          [31.2, -37.0],
          [31.1, -36.7],
          [31.3, -36.5],
        ],
      },
      {
        name: "volteggio",
        origCenter: [33.0, -35.9],
        polygonVertices: [
          [32.8, -35.6],
          [33.1, -35.5],
          [33.3, -35.7],
          [33.2, -36.1],
          [32.8, -36.2],
          [32.6, -35.9],
          [32.6, -35.7],
          [32.8, -35.6],
        ],
      },
      {
        name: "spring",
        origCenter: [30.8, -34.8],
        polygonVertices: [
          [30.5, -34.5],
          [30.9, -34.4],
          [31.2, -34.7],
          [31.2, -35.1],
          [30.8, -35.2],
          [30.4, -35.0],
          [30.4, -34.7],
          [30.5, -34.5],
        ],
      },
    ],
  },
  {
    id: "city3d",
    name: "wow",
    origCenter: [29, -44],
    polygonVertices: [
      [28.4, -42.4],
      [29.2, -42.2],
      [30.0, -42.6],
      [30.6, -43.2],
      [30.8, -43.8],
      [30.4, -44.6],
      [30.6, -45.2],
      [30.0, -45.8],
      [29.2, -45.6],
      [28.4, -45.8],
      [27.6, -45.2],
      [27.2, -44.6],
      [27.0, -43.8],
      [27.4, -43.2],
      [27.8, -42.8],
      [28.4, -42.4],
    ],
    comuni: [
      {
        name: "icarus",
        origCenter: [29.0, -45.0],
        polygonVertices: [
          [28.7, -44.7],
          [29.1, -44.6],
          [29.4, -44.8],
          [29.4, -45.2],
          [29.0, -45.4],
          [28.6, -45.2],
          [28.5, -44.9],
          [28.7, -44.7],
        ],
      },
      {
        name: "klein",
        origCenter: [29.5, -43.2],
        polygonVertices: [
          [29.2, -42.9],
          [29.6, -42.8],
          [29.9, -43.0],
          [30.0, -43.3],
          [29.7, -43.6],
          [29.3, -43.5],
          [29.1, -43.3],
          [29.2, -42.9],
        ],
      },
    ],
  },
];

let cachedGuitarsOffsets: Record<string, { dx: number; dy: number }> | null =
  null;

function generateRandomGuitarsOffsets(): Record<
  string,
  { dx: number; dy: number }
> {
  const result: Record<string, { dx: number; dy: number }> = {};
  const placedCenters: Record<string, [number, number]> = {};

  for (const city of GUITARS_CITIES_BASE) {
    let placed = false;
    let minDistance = 4.5;

    for (let attempt = 0; attempt < 3000; attempt++) {
      if (attempt === 1500) minDistance = 3.5;
      if (attempt === 2500) minDistance = 2.5;

      const newX = Math.round((23.5 + Math.random() * 16.5) * 10) / 10;
      const newY = Math.round((-48.5 + Math.random() * 16.5) * 10) / 10;
      const dx = newX - city.origCenter[0];
      const dy = newY - city.origCenter[1];

      let tooClose = false;

      // Avoid region label "Guitars" at center [30, -40]
      if (Math.abs(newX - 30) < 4.0 && Math.abs(newY - (-40)) < 3.0) {
        continue;
      }

      for (const otherId in placedCenters) {
        const dist = Math.hypot(
          newX - placedCenters[otherId][0],
          newY - placedCenters[otherId][1],
        );
        if (dist < minDistance) {
          tooClose = true;
          break;
        }
      }
      if (tooClose) continue;

      let allInside = true;
      const poly = city.polygonVertices;
      for (let i = 0; i < poly.length; i++) {
        const v = poly[i];
        const nextV = poly[(i + 1) % poly.length];
        const shiftedV: [number, number] = [v[0] + dx, v[1] + dy];
        const midV: [number, number] = [
          (v[0] + nextV[0]) / 2 + dx,
          (v[1] + nextV[1]) / 2 + dy,
        ];

        // Must stay inside region polygon AND outside region label box
        if (
          !isPointInPolygon(shiftedV, GUITARS_REGION_VERTICES) ||
          !isPointInPolygon(midV, GUITARS_REGION_VERTICES) ||
          (Math.abs(shiftedV[0] - 30) < 3.5 &&
            Math.abs(shiftedV[1] - -40) < 2.2) ||
          (Math.abs(midV[0] - 30) < 3.5 && Math.abs(midV[1] - -40) < 2.2)
        ) {
          allInside = false;
          break;
        }
      }

      if (allInside) {
        result[city.id] = { dx, dy };
        placedCenters[city.id] = [newX, newY];
        placed = true;
        break;
      }
    }

    if (!placed) {
      result[city.id] = { dx: 0, dy: 0 };
      placedCenters[city.id] = city.origCenter;
    }
  }

  return result;
}

function getGuitarsCities(): any[] {
  cachedGuitarsOffsets = generateRandomGuitarsOffsets();
  return GUITARS_CITIES_BASE.map((cityBase) => {
    const offset = cachedGuitarsOffsets![cityBase.id] || { dx: 0, dy: 0 };
    const shiftedVertices = cityBase.polygonVertices.map(
      (v): [number, number] => [v[0] + offset.dx, v[1] + offset.dy],
    );
    return {
      id: cityBase.id,
      name: cityBase.name,
      coordinates: [
        cityBase.origCenter[0] + offset.dx,
        cityBase.origCenter[1] + offset.dy,
      ],
      geometry: new Polygon([shiftedVertices]),
    };
  });
}

export const getRegions = (): MapRegion[] => [
  {
    id: 1,
    name: "Contacts",
    center: [-54, 28],
    section: "contacts",
    geometry: new Polygon([
      [
        [-58, 32],
        [-54, 34],
        [-50, 32],
        [-48, 28],
        [-49, 24],
        [-52, 20],
        [-56, 18],
        [-58, 22],
        [-58, 28],
        [-58, 32],
      ],
    ]),
    cities: [
      {
        id: "city1a",
        name: "Porto Sereno",
        coordinates: [-55.2, 31.2],
        geometry: new Polygon([
          [
            [-57.0, 31.0],
            [-56.0, 30.5],
            [-54.0, 30.2],
            [-52.5, 31.0],
            [-52.2, 32.5],
            [-53.0, 33.0],
            [-55.0, 32.8],
            [-56.5, 32.5],
            [-57.0, 31.0],
          ],
        ]),
      },
      {
        id: "city1b",
        name: "Valle Solare",
        coordinates: [-50.8, 26.8],
        geometry: new Polygon([
          [
            [-51.8, 25.5],
            [-50.5, 25.2],
            [-50.0, 26.5],
            [-49.8, 28.0],
            [-50.5, 28.5],
            [-51.2, 28.2],
            [-52.0, 27.5],
            [-51.8, 25.5],
          ],
        ]),
      },
      {
        id: "city1c",
        name: "Monte Nebbioso",
        coordinates: [-55.4, 22.1],
        geometry: new Polygon([
          [
            [-58.0, 23.0],
            [-57.0, 24.5],
            [-55.0, 24.8],
            [-53.0, 23.5],
            [-52.5, 22.0],
            [-53.2, 21.5],
            [-55.0, 21.0],
            [-56.5, 20.5],
            [-57.5, 21.5],
            [-58.0, 23.0],
          ],
        ]),
      },
      {
        id: "city1d",
        name: "Fiume Calmo",
        coordinates: [-52.3, 29.5],
        geometry: new Polygon([
          [
            [-53.0, 29.5],
            [-52.3, 30.2],
            [-50.5, 29.8],
            [-50.8, 28.5],
            [-51.5, 27.8],
            [-53.0, 29.5],
          ],
        ]),
      },
    ],
  },
  {
    id: 2,
    name: "About",
    center: [-37.3, 52.3],
    section: "about",
    geometry: new Polygon([
      [
        [-42, 54],
        [-39, 57],
        [-35, 56],
        [-33, 53],
        [-34, 50],
        [-37, 48],
        [-40, 49],
        [-42, 52],
        [-42, 54],
      ],
    ]),
    cities: [
      {
        id: "city2a",
        name: "concept",
        coordinates: [-38.2, 56.1],
        geometry: new Polygon([
          [
            [-38.2, 56.6],
            [-37.9, 56.5],
            [-37.6, 56.2],
            [-37.5, 55.9],
            [-37.6, 55.6],
            [-37.9, 55.4],
            [-38.2, 55.3],
            [-38.5, 55.4],
            [-38.8, 55.5],
            [-39.0, 55.8],
            [-38.9, 56.1],
            [-38.6, 56.4],
            [-38.2, 56.6],
          ],
        ]),
      },
      {
        id: "city2b",
        name: "filosofy",
        coordinates: [-36.2, 53.6],
        geometry: new Polygon([
          [
            [-36.8, 53.6],
            [-36.5, 53.9],
            [-36.1, 54.0],
            [-35.7, 53.9],
            [-35.4, 53.7],
            [-35.3, 53.4],
            [-35.5, 53.2],
            [-35.8, 53.1],
            [-36.2, 53.0],
            [-36.5, 53.1],
            [-36.8, 53.3],
            [-36.8, 53.6],
          ],
        ]),
      },
      {
        id: "city2c",
        name: "quality",
        coordinates: [-37.8, 50.6],
        geometry: new Polygon([
          [
            [-37.8, 51.1],
            [-37.5, 51.0],
            [-37.3, 50.7],
            [-37.2, 50.4],
            [-37.4, 50.1],
            [-37.7, 49.9],
            [-38.0, 50.0],
            [-38.3, 50.2],
            [-38.4, 50.5],
            [-38.3, 50.8],
            [-38.1, 51.0],
            [-37.8, 51.1],
          ],
        ]),
      },
      {
        id: "city2d",
        name: "biography",
        coordinates: [-40.7, 51.6],
        geometry: new Polygon([
          [
            [-40.7, 52.2],
            [-40.4, 52.1],
            [-40.2, 51.8],
            [-40.1, 51.5],
            [-40.2, 51.2],
            [-40.3, 50.9],
            [-40.6, 50.7],
            [-40.9, 50.8],
            [-41.1, 51.0],
            [-41.2, 51.3],
            [-41.1, 51.7],
            [-41.0, 52.0],
            [-40.7, 52.2],
          ],
        ]),
      },
    ],
  },
  {
    id: 3,
    name: "Guitars",
    center: [30, -40],
    section: "guitars",
    geometry: new Polygon([GUITARS_REGION_VERTICES]),
    cities: getGuitarsCities(),
  },
];

export const getComuniData = (): Record<string, MapComune[]> => {
  if (!cachedGuitarsOffsets) {
    cachedGuitarsOffsets = generateRandomGuitarsOffsets();
  }

  const comuniData: Record<string, MapComune[]> = {
    city1a: [
      {
        name: "Email",
        coordinates: [-55.6, 30.1],
        tooltip: "info@tarazum.com",
        href: "mailto:info@tarazum.com",
      },
      {
        name: "Phone",
        coordinates: [-52.8, 32.4],
        tooltip: "+39 338 685 5006",
        href: "tel:+393386855006",
      },
    ],

    city1b: [
      {
        name: "Where",
        coordinates: [-51.2, 26.4],
        tooltip: "Via P. Maroncelli, Meda (MB), Italy",
        href: "https://maps.app.goo.gl/9ygrd5WwVtrKoaKLA",
        target: "_blank",
      },
    ],

    city1c: [
      {
        name: "Facebook",
        coordinates: [-57, 24],
        tooltip: "Seguici su Facebook",
        href: "https://www.facebook.com/tarazumguitars",
        target: "_blank",
      },
      {
        name: "Instagram",
        coordinates: [-55.8, 21.6],
        tooltip: "Seguici su Instagram",
        href: "https://www.instagram.com/tarazumguitars",
        target: "_blank",
      },
      {
        name: "YouTube",
        coordinates: [-53.0, 22.6],
        tooltip: "Guarda i video su YouTube",
        href: "https://www.youtube.com/@tarazumguitars4421",
        target: "_blank",
      },
    ],
  };

  for (const cityBase of GUITARS_CITIES_BASE) {
    const offset = cachedGuitarsOffsets[cityBase.id] || { dx: 0, dy: 0 };
    comuniData[cityBase.id] = cityBase.comuni.map((comune) => {
      const coord: [number, number] = [
        comune.origCenter[0] + offset.dx,
        comune.origCenter[1] + offset.dy,
      ];
      const comuneObj: MapComune = {
        name: comune.name,
        coordinates: coord,
      };
      if (comune.tooltip) comuneObj.tooltip = comune.tooltip;
      if (comune.href) comuneObj.href = comune.href;
      if (comune.target) comuneObj.target = comune.target;

      if (comune.polygonVertices) {
        const shiftedVertices = comune.polygonVertices.map(
          (v): [number, number] => [v[0] + offset.dx, v[1] + offset.dy],
        );
        comuneObj.geometry = new Polygon([shiftedVertices]);
      }
      return comuneObj;
    });
  }

  return comuniData;
};

